<template>
	<NoLineBreaks>
		<Badge :status="valueRef ? 'success' : 'error'" />
		{{ $t('license.fields.' + (valueRef ? 'yes' : 'no')) }}
	</NoLineBreaks>
</template>

<script>
import { computed, toRef } from 'vue';
import { Badge } from 'ant-design-vue';

import NoLineBreaks from '@/components/common/NoLineBreaks';

import { useLicenseStore } from '@/stores/licenseStore';

export default {
	components: {
		Badge, NoLineBreaks,
	},
	props: ['field'],
	setup(props) {
		const licenseStore = useLicenseStore();
		const fieldRef = toRef(props, 'field');
		const valueRef = computed(() => licenseStore[fieldRef.value]);
		return {
			valueRef,
		};
	},
}
</script>